import { getConfig } from "../config";

export type SalesforceObject = "Opportunity" | "Quote" | "Account" | "User";

/** Lightning record URL for a Salesforce object, using the org base URL from runtime config. */
export function salesforceRecordUrl(object: SalesforceObject, recordId: string): string {
  const base = getConfig().SALESFORCE_BASE_URL.replace(/\/+$/, "");
  return `${base}/lightning/r/${object}/${encodeURIComponent(recordId)}/view`;
}
